import React, { memo, useState, useEffect }  from 'react'
import SectionHomeDesktop from './SectionHomeDesktop'
import SectionHomeReponsive from './SectionHomeResponsive'

function SectionHome() {
  const [windowWidth, setWindowWidth] = useState(0)
  let resizeWindow = () => setWindowWidth(window.innerWidth)

  useEffect(() => {
    resizeWindow()
    window.addEventListener('resize', resizeWindow)
    return () => window.removeEventListener('resize', resizeWindow)
  }, [])

  return (
    <>
      {
        windowWidth >= 1185 ? 
          <SectionHomeDesktop /> : 
          <SectionHomeReponsive />
      }
    </>
  )
}

export default memo(SectionHome)
